__webpack_require__.p = "/lazy-adyen/referrals-hub/";